import { Row, Col } from 'reactstrap';
import type { ArticleReference } from 'domain-model/types/oms';
import { ArticleCarouselCard } from '../../article/ArticleCard';
import Carousel, { CarouselSlide } from '../../Carousel';
import _ from 'lodash';

interface ArticleCarouselWithImage {
  id: string;
  blockType: 'imageToTheRight' | 'imageToTheLeft';
  image: string;
  useBackgroundImage: boolean;
  backgroundColor: string;
  backgroundImage: string;
  query: object;
  articles: any;
}

function CarouselAndImageComponent({
  articleCarouselWithImage,
}: {
  articleCarouselWithImage: ArticleCarouselWithImage;
}) {
  const { useBackgroundImage, backgroundColor, backgroundImage, articles } =
    articleCarouselWithImage;
  const carouselContainerStyles = {
    height: '440px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    paddingTop: '57px',
    backgroundImage: 'none',
    backgroundColor: 'white',
  };
  if (useBackgroundImage) {
    carouselContainerStyles.backgroundImage = `url(${backgroundImage})`;
  } else {
    carouselContainerStyles.backgroundColor = backgroundColor;
  }

  let imageClassNames = '';
  let carouselClassName = '';
  if (articleCarouselWithImage.blockType === 'imageToTheRight') {
    imageClassNames += 'order-first order-md-last ps-md-0';
    carouselClassName += 'order-last order-md-first pe-md-0';
  }
  if (articleCarouselWithImage.blockType === 'imageToTheLeft') {
    imageClassNames += 'order-first pe-md-0';
    carouselClassName += 'order-last ps-md-0';
  }

  return (
    <Row className="g-0">
      <Col
        md={5}
        xxl={4}
        className={`${imageClassNames} article-carousel-with-image`}
      >
        <div
          style={{
            backgroundImage: `url(${articleCarouselWithImage.image})`,
            height: '440px',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        />
      </Col>
      <Col md={7} xxl={8} className={`${carouselClassName}`}>
        <div style={carouselContainerStyles} className="px-4">
          <Carousel
            key={articleCarouselWithImage.id}
            id={articleCarouselWithImage.id}
            minHeight={'0'}
            className="p-2 article-carousel"
          >
            {articles?.length &&
              articles.map((article: ArticleReference) => (
                <CarouselSlide
                  key={article?.id}
                  className="bg-light"
                  style={{}}
                >
                  <ArticleCarouselCard article={article} />
                </CarouselSlide>
              ))}
          </Carousel>
        </div>
      </Col>
    </Row>
  );
}

export default CarouselAndImageComponent;
